module.exports = __webpack_public_path__ + "bf6f9b0191659c38159deced45dcb8e4.svg";